import { render, staticRenderFns } from "./ModelTeamIncomeSendRecord.vue?vue&type=template&id=34633bfc&scoped=true&"
import script from "./ModelTeamIncomeSendRecord.vue?vue&type=script&lang=js&"
export * from "./ModelTeamIncomeSendRecord.vue?vue&type=script&lang=js&"
import style0 from "./ModelTeamIncomeSendRecord.vue?vue&type=style&index=0&id=34633bfc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34633bfc",
  null
  
)

export default component.exports